import React from 'react';
import { useSelector } from 'react-redux';

import store from '../../../../store';
import type { RootState } from '../../../../store/models';
import { PublicProviderProfile } from '../../../../modules/Api.types';
import {
  buildPageData,
  buildBreadCrumbData,
  buildProviderEntityData,
} from './ProfileSchemaService';
import { ClientProviderProfile } from '../../../../api/ProfileClientView';
import { ProviderServiceGroup } from '../../../../api/Providers/ServiceGroups';

export type ProfileSchemaProps = {
  profile: PublicProviderProfile | ClientProviderProfile,
  serviceGroups?: ProviderServiceGroup[],
  ratingCount?: number,
  reviewCount?: number,
};

const ProfileSchema = React.memo(({
  profile,
  serviceGroups,
  ratingCount,
  reviewCount,
}: ProfileSchemaProps) => {
  const reviews = useSelector<RootState, any>(
    store.select.providerReviews.forPro({ providerId: profile?.id }),
  ) || {};
  const ratingsSummary = useSelector<RootState, any>(
    store.select.ratingsSummary.forPro({ profileId: profile?.id }),
  ) || {};

  const reviewTotal = reviewCount || reviews?.total || 0;
  const ratingTotal = ratingCount || ratingsSummary?.total || 0;

  if (!profile) {
    return null;
  }

  return (
    <React.Fragment>
      <script type="application/ld+json">
        {JSON.stringify(buildPageData(profile), null, 3)}
      </script>
      <script type="application/ld+json">
        {JSON.stringify(buildBreadCrumbData(profile), null, 3)}
      </script>
      <script type="application/ld+json">
        {JSON.stringify(buildProviderEntityData(
          profile,
          serviceGroups,
          ratingTotal,
          reviewTotal,
        ), null, 3)}
      </script>
    </React.Fragment>
  );
});

export default ProfileSchema;
